import { get } from '@apps-payroll/lib/request/svc/payroll/http';

export type StatusResponse = {
  success: boolean;
  data: {
    onboarded: boolean;
    provider: string;
    isMultiEntity: boolean;
  };
};

export async function getPayrollStatus(): Promise<StatusResponse> {
  try {
    const response = await get(`/status`);
    return response.data;
  } catch (e) {
    let errorMessage = 'failed to get payroll status';
    if (e instanceof Error) {
      errorMessage = e.message;
    }
    throw new Error(errorMessage);
  }
}

export default getPayrollStatus;
